import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25 12.857c0 .304-.123.589-.334.804l-7.875 8A1.11 1.11 0 0 1 16 22c-.3 0-.58-.125-.791-.339l-7.875-8a1.142 1.142 0 0 1 .791-1.947h15.75c.615 0 1.125.518 1.125 1.143Z" }));
const ForwardRef = forwardRef(SvgTriangleDown);
export default ForwardRef;
